module.exports = __webpack_public_path__ + "static/media/broof_logo.97e9a8e6.png";